export * from "./client";
export * from "./queries";
export * from "./services";

declare global {
	namespace PrismaJson {}
}
